import type { FaireProductEntity } from "../../entity_types/product";

export const p_72xm8ygn4y: FaireProductEntity = {
  token: "p_72xm8ygn4y",
  type: "product",
  name: "ALO Aloe Vera Juice/3-Flavor Variety/16.9 FL OZ, Pack of 12",
  brandToken: "b_7h76tk1dcp",
  brandName: "ALO drink",
  imageUrl:
    "https://cdn.faire.com/fastly/10e557a1e1c7483fb15d6486565ab3c483bae055948a3eb78c16b6b271fc8524.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/64bbe4ae20c1460a836551bc72e51fd6f96443a932829f70b1f2ea6022d883df.jpeg",
    "https://cdn.faire.com/fastly/66f383c6f9c55c9eecc6cf8df357025112258d26688a5fd5dfcaee25fa9b55ab.jpeg",
    "https://cdn.faire.com/fastly/a4660fbe20af6ccb4480a413192137949ec7f61114d140d2847a4565b9aa7ac2.jpeg",
    "https://cdn.faire.com/fastly/81cd220d41618ac829b6247a31314b3c2c5458f5fff513fb5772a74ff613e648.jpeg",
  ],
  priceDollars: 2.02,
  description:
    "ALO Aloe Vera Juice | 16.9 fl oz, Pack of 12 | 3-Flavor Variety Pack | ALLURE, COMFORT, EXPOSED Plant-Based Drink\n\n* VARIETY IS THE DRINK OF LIFE: Try 4 each of our 3 Fan Favorites; COMFORT with Aloe,     Watermelon and Peach; ALLURE with a lively tropical blend; EXPOSED with Aloe and Honey\n\n* NATURAL, PLANT-BASED GOODNESS: Real aloe vera juice and pulp straight from the leaf – never from powder; ALO Original waters are sweetened with real cane sugar; Aloin free, Fat free, and Non-GMO Project Certified\n\n* FARM-TO-BOTTLE DELICIOUSNESS: Great flavor comes from using real fruit and vegetable juices as well as organic and other fine ingredients combined with real, fresh aloe juice and pulp; No artificial anything\n\n* RESPONSIBLY SOURCED FROM THAILAND: Aloe vera is a strong and robust plant that can be planted in fields otherwise unconducive to farming; By using very little water aloe is able to be harvested several times a year\n\n* GOODNESS FROM INSIDE OUT: There is an ALO flavor for everybody and for every mood, we create aloe vera juices with creative and unique flavor combinations to inspire an active lifestyle from farm to store",
  tags: [],
  msrpDollars: 4.05,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:28.143Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
